import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { Dialog } from '@material-ui/core';
import CancelIcon from '@mui/icons-material/Cancel';
import { EAA_Btn } from '~/components/EditAndAddItem';
import { rightColor } from '~/components/EditAndAddItem/common';

class CheckTime extends Component {
   renderDialog=() => {
     const { clearKey } = this.props;
     return (
       <div style={{ width: 515, height: 458, backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
         <CancelIcon style={{ width: 162, height: 185, color: 'red', marginTop: 44, marginBottom: 12 }} />
         <div style={{ fontSize: 25, marginBottom: 41 }}>
           起始時間不可晚於結束時間，請重新設定。
         </div>
         <div style={{ display: 'flex' }}>
           <EAA_Btn text='確認' style={{ height: 47, width: 155 }} backgroundColor={rightColor} onClick={clearKey} />
         </div>
       </div>
     );
   }

   render () {
     const { checkTime = false } = this.props;
     return (
       <Dialog
         PaperComponent={this.renderDialog}
         open={checkTime}
       />
     );
   }
}

const mapStateToProps = state => ({
  checkTime: state.data.CheckTime,
});
const mapDispatchToProps = dispatch => ({
  clearKey: () => Actions.clearKey(dispatch, { key: 'CheckTime' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckTime);
